<div *ngIf="gameDetails && gameDetails.gdContent" class="games_contentsection" >
  <div class="container">
      <div class="col-xs-12 col-sm-12 col-md-8">
      <h4>{{gameDetails.name}}</h4>
      <p [innerHtml] = "gameDetails.gdContent | safeHtml"></p>
      <ng-container *ngIf="(gameDetails.tagList.length > 0)">
        <button class="content_btn" *ngFor="let tagName of gameDetails.tagList">{{tagName}}</button>
      </ng-container>
    </div>
  </div>
</div>